import { getI18n } from './lib/context';
import { createElement } from 'react';
export { I18nContext, registerReactInstance } from './lib/context';
export { IntlProvider } from './lib/Provider';
export { Trans } from './lib/Trans';
export { useTranslation } from './lib/useTranslation';
export { withTranslation } from './lib/withTranslation';
export function getHtml(keys, options, fallbackText) {
    var i18n = getI18n() || { t: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args[0];
        } };
    var t = i18n.t;
    return createElement('span', {
        dangerouslySetInnerHTML: {
            __html: t ? t(keys, options, fallbackText) : keys
        }
    });
}
//# sourceMappingURL=index.js.map